export class Faq {
	id: number;
	id_faq_topic: string ='1';
	position: number;
    subject: string = '';
    keyword: string = '';
    details: string = '';
}
